// @ts-check
const numVersionRegexp = /(.*)(\d+)/

/**
 * @param {number|string|undefined} _nrvVersion
 * @param {number|string} nrvUiVersionFromClient
 * @return {{nrvVersion: string, nrvUiVersion: string}}
 */
export function getNrvVersions (_nrvVersion, nrvUiVersionFromClient) {
  const nrvVersion = _nrvVersion || nrvUiVersionFromClient
  const nrvUiVersion = _nrvVersion === nrvUiVersionFromClient ? nrvUiVersionFromClient.toString() : getNrvUiVersion(nrvVersion, nrvUiVersionFromClient)
  return {
    nrvVersion: nrvVersion.toString(),
    nrvUiVersion
  }
}

/**
 * @param {number|string} nrvVersion
 * @param {number|string} nrvUiVersionFromClient
 * @return {string}
 */
function getNrvUiVersion (nrvVersion, nrvUiVersionFromClient) {
  if (bothNumeric(nrvVersion, nrvUiVersionFromClient)) {
    return Math.max(Number(nrvVersion), Number(nrvUiVersionFromClient)).toString()
  } else if (isOnlyNrvVerisonNumeric(nrvVersion, nrvUiVersionFromClient)) {
    return nrvUiVersionFromClient.toString()
  } else {
    return getNrvUiVersionFromString(nrvVersion.toString(), nrvUiVersionFromClient.toString())
  }
}

/**
 * @param {string} nrvVersion
 * @param {string} nrvUiVersionFromClient
 * @return {string}
 */
function getNrvUiVersionFromString (nrvVersion, nrvUiVersionFromClient) {
  const nrvVersionParts = nrvVersion.split('/')
  const nrvVersionNumber = nrvVersionParts.pop()
  const nrvUiVersionFromClientParts = nrvUiVersionFromClient.split('/')
  const nrvUiVersionFromClientNumber = nrvUiVersionFromClientParts.pop()
  if (nrvVersionParts.join('/') === nrvUiVersionFromClientParts.join('/')) {
    const [, clientVersionPrefix, clientNum] = nrvUiVersionFromClientNumber.match(numVersionRegexp)
    const [, nrvVersionPrefix, nrvVersionNum] = nrvVersionNumber.match(numVersionRegexp)
    const nrvUiVersion = clientVersionPrefix === nrvVersionPrefix
      ? `${nrvVersionParts.join('/')}/${clientVersionPrefix}${Math.max(clientNum, nrvVersionNum)}`
      : nrvUiVersionFromClient
    return nrvUiVersion
  } else {
    return nrvUiVersionFromClient
  }
}

/**
 * @param {string|number} a
 * @param {string|number} b
 * @returns {boolean}
 */
function bothNumeric (a, b) {
  return isNumeric(a) && isNumeric(b)
}

/**
 * @param {string|number} nrvVersion
 * @param {string|number} nrvUiVersionFromClient
 * @returns {boolean}
 */
function isOnlyNrvVerisonNumeric (nrvVersion, nrvUiVersionFromClient) {
  return isNumeric(nrvVersion) && !isNumeric(nrvUiVersionFromClient)
}

/**
 * @param {number|string} num
 * @returns {num is number}
 */
function isNumeric(num) {
  return !isNaN(num)
}
